import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class UpdateAISummaryInDisputeByRecordingUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (record: string, params: any): Promise<any> => {
        return await this._aiRepository.UpdateAISummaryInDisputeByRecord(record, params);
    }
}

export const UpdateAISummaryInDisputeByRecordingUseCaseName = "UpdateAISummaryInDisputeByRecordingUseCaseName";